// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GIE3","newExpiryDate":"styles_newExpiryDate__3sTgF","footer":"styles_footer__2GXfa"};